import { withNamespaces } from 'react-i18next';
import { UncontrolledTooltip } from 'reactstrap';

export const ACTIVATED_FUNCTION_DEFINITIONS = [
    {
        key: 'CS',
        title: 'Compliance Screening',
    },
    {
        key: 'RDM',
        title: 'Risk Decision Matrix',
    },
    {
        key: 'CM',
        title: 'Compliance Monitoring',
    },
    {
        key: 'DNB',
        title: 'Dun & Bradstreet',
    },
    {
        key: 'EGD',
        title: 'EUDR Geodata',
    },
    {
        key: 'ANM',
        title: 'Adverse News Monitoring',
    },
];

const tooltipIdFor = (idPrefix, key) => (
    `${idPrefix}-${key}`.replace(/[^A-Za-z0-9_-]/g, '')
);

const ActivatedFunctions = ({
    functions,
    idPrefix,
    t,
}) => {
    if (!functions || typeof functions !== 'object' || Array.isArray(functions)) {
        return '---';
    }

    const knownKeys = ACTIVATED_FUNCTION_DEFINITIONS.map((item) => item.key);
    const items = [
        ...ACTIVATED_FUNCTION_DEFINITIONS.filter((item) => (
            Object.prototype.hasOwnProperty.call(functions, item.key)
        )),
        ...Object.keys(functions)
            .filter((key) => !knownKeys.includes(key))
            .map((key) => ({
                key,
                title: key,
            })),
    ];

    if (!items.length) {
        return '---';
    }

    return (
        <span className="activated-functions">
            {items.map((item) => {
                const isActive = functions[item.key] === true;
                const tooltipId = tooltipIdFor(idPrefix, item.key);

                return (
                    <span key={item.key}>
                        <span
                            id={tooltipId}
                            className={`activated-functions__chip${isActive ? ' is-active' : ''}`}
                        >
                            {item.key}
                        </span>
                        <UncontrolledTooltip
                            placement="top"
                            target={tooltipId}
                        >
                            {`${t(item.title)} — ${t(isActive ? 'Active' : 'Not active')}`}
                        </UncontrolledTooltip>
                    </span>
                );
            })}
        </span>
    );
};

export default withNamespaces()(ActivatedFunctions);
